import { RouteObject, createBrowserRouter } from 'react-router-dom';
import { AuthGuard, GuestGuard } from './guards';
import { AppRouteLayout, FullScreenLayout, RootLayout } from './layouts';
import { appRouteModules, fullScreenRouteModules, guestRouteModules } from './routes';

// 비인증 라우트 설정
export const nonAuthedRoutes: RouteObject = {
	element: <GuestGuard />,
	children: [
		{
			element: <RootLayout />,
			children: guestRouteModules,
		},
	],
};

// 인증 라우트 설정
export const authedRoutes: RouteObject = {
	element: <AuthGuard />,
	children: [
		{
			element: <RootLayout />,
			children: [
				// 헤더 포함 레이아웃
				{
					element: <AppRouteLayout />,
					children: appRouteModules,
				},
				// 헤더 비포함 레이아웃 (풀스크린)
				{
					element: <FullScreenLayout />,
					children: fullScreenRouteModules,
				},
			],
		},
	],
};

// 전체 라우트 구성
const routes: RouteObject[] = [nonAuthedRoutes, authedRoutes];

export const router = createBrowserRouter(routes);
